import { HELP_TABS } from 'xm-constants/helpView';
import { getHasCompanySupervisorPermission } from 'selectors/loggedInUser';
import {
  getIsOnFreePlan,
  getIsQuickStartGuideEnabled,
} from 'selectors/featureToggles';

const DEFAULT_TAB = HELP_TABS.HELP;

// This is in the helpView selectors because long-term that is where QSG will always live:
export const getHasQuickStartGuide = state =>
  getHasCompanySupervisorPermission(state) &&
  getIsOnFreePlan(state) &&
  getIsQuickStartGuideEnabled(state);

export const getCurrentTab = state => {
  const tab = state.helpPopover.currentTab;
  if (tab === HELP_TABS.QUICK_START && !getHasQuickStartGuide(state)) {
    return DEFAULT_TAB;
  }
  return HELP_TABS[tab] || DEFAULT_TAB;
};

const currentTabIsQuickStart = state =>
  getCurrentTab(state) === HELP_TABS.QUICK_START;
const currentTabIsHelp = state => getCurrentTab(state) === HELP_TABS.HELP;

export const getIsHelpDrawerOpen = state =>
  state.helpPopover.isOpen &&
  (!!state.helpPopover.helpLocation || currentTabIsQuickStart(state));

export const getIsHelpTabOpen = state =>
  getIsHelpDrawerOpen(state) && currentTabIsHelp(state);

export const getIsHelpQuickStartOpen = state =>
  getIsHelpDrawerOpen(state) && currentTabIsQuickStart(state);
